"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseButton = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./DownloadButton.scss");
var PauseButton = function (props) {
    return (react_1.default.createElement("div", { className: classnames_1.default('pause-button', { tooltip: props.showTooltip }, props.tooltipPosition), "data-tooltip": "Pause Transfer", style: { lineHeight: '1rem' } },
        react_1.default.createElement("a", { onClick: props.onDownloadStop },
            react_1.default.createElement("i", { className: "fas fa-pause" }),
            !props.showTooltip &&
                react_1.default.createElement("p", null, "Pause"))));
};
exports.PauseButton = PauseButton;
